import { del, get, post, put } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getFinancialServices = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/financialservices`);
};

const loadWheelSizes = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/wheelSizes`);
};

const computeOfferFinancialServices = (documentId, siteId, header, serviceDetails) => {
  return post(`${url}/leasingoffers/${documentId}/${siteId}/financialservices/compute`, {
    documentId,
    siteId,
    header,
    serviceDetails
  });
};

const updateOfferFinancialServices = (documentId, siteId, header, services, useExtendedFields) => {
  return put(`${url}/leasingoffers/${documentId}/${siteId}/financialservices`, {
    documentId,
    siteId,
    header,
    services,
    useExtendedFields
  });
};

const addServices = (documentId, siteId, addedServices) => {
  return put(`${url}/leasingoffers/${documentId}/${siteId}/add-services`, {
    documentId,
    siteId,
    addedServices
  });
};

const deleteService = (documentId, siteId, deletedServiceId) => {
  return del(`${url}/leasingoffers/${documentId}/${siteId}/delete-service/`, {
    documentId,
    siteId,
    deletedServiceId
  });
};

const getInsuranceCompanies = (documentId, siteId) =>
  get(`${url}/leasingoffers/${documentId}/${siteId}/insuranceCompanies`);

const getFinancialServicesLinking = (documentId, siteId) =>
  get(`${url}/leasingoffers/${documentId}/${siteId}/service-linking`);

const getFinancialServiceTypes = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/service-types`);
};

const exp = {
  getFinancialServices,
  loadWheelSizes,
  computeOfferFinancialServices,
  updateOfferFinancialServices,
  getInsuranceCompanies,
  getFinancialServicesLinking,
  getFinancialServiceTypes,
  addServices,
  deleteService
};
export default exp;
